const ChevronUp = (props) => {
  return (
    <svg width="22" height="12" viewBox="0 0 23 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
     <path d="M4.00001 2.31822L0.888878 5.5L-7.94746e-08 4.59092L4.00001 0.5L8 4.59092L7.11111 5.5L4.00001 2.31822Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export default ChevronUp;
